import { v4 as uuidv4 } from 'uuid';
import { getDiscoverPublishersAPI } from './api';
import {
    DIRECTORY_PAGE_LIMIT,
    preparePublisherData,
    deriveDirectoryFilterIndustries,
} from './getDirectoryPublishers';

// Mirrors loadMoreDirectoryPublishers's guards, scoped to search mode's own
// page/hasMore cursor (EBL-13117). Also checks searchQuery matches the
// current search text — VirtuosoGrid's endReached can fire again the moment
// a short result set renders, in the gap between a new query being typed
// (search.searchText updates instantly) and that query's own page-1 fetch
// resolving searchHasMore/searchPage — without this check, a load-more
// fired in that gap would use the PREVIOUS query's (possibly stale-true)
// hasMore/page against the NEW query text, requesting a page past what
// that query actually has (the backend has a real bug on that: an
// out-of-range page for a search 500s rather than returning empty).
function canLoadMoreSearchResults(store) {
    return store.searchHasMore
        && store.searchQuery === store.search.searchText.trim()
        && !store.observed.directoryPublishersSearching
        && !store.observed.directoryPublishersSearchingMore;
}

async function loadMoreSearchResults() {
    if (!canLoadMoreSearchResults(this)) return;

    this.observed.directoryPublishersSearchingMore = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;
        const nextPage = this.searchPage + 1;
        const query = this.search.searchText.trim();

        const res = await getDiscoverPublishersAPI({
            token: session?.token,
            traceId,
            page: nextPage,
            limit: DIRECTORY_PAGE_LIMIT,
            search: query,
        });
        // See loadMoreDirectoryPublishers.js — the API layer resolves (never
        // rejects) even on failure, so bail out without advancing
        // searchPage/searchHasMore rather than skip a page.
        if (!res?.data) return;

        const data = res.data?.data || res.data;
        const publishers = data?.publishers || [];
        const colored = preparePublisherData(publishers, this.whatshotPublishers);

        this.searchDirectoryResults = [...this.searchDirectoryResults, ...colored];
        this.directoryFilterIndustries = deriveDirectoryFilterIndustries(this.searchDirectoryResults);
        this.searchPage = nextPage;
        this.searchHasMore = !!data?.hasNextPage;
        this.observed.searchDirectoryResults = uuidv4();
        this.applyDirectoryFilter();
    } finally {
        this.observed.directoryPublishersSearchingMore = false;
    }
}

export default loadMoreSearchResults;
